<template>
  <v-flex xs12 class="mb-4">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between vertical-center-container">
          <page-title :routeProps="routeProps"></page-title>
        </div>
      </v-card-title>
      <div class="mx-3 mb-5">
        <card-divider-full></card-divider-full>
      </div>

      <v-card-actions></v-card-actions>
      <v-btn
        fab
        dark
        color="blue darken-4"
        class="overlap-fab"
        @click="addDocketDialog = true"
        v-if="userAuthClass"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-card>

    <docket-add-wrapper v-model="addDocketDialog" v-if="userAuthClass"></docket-add-wrapper>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketService from "@/services/requests/docketService";
import DocketAddWrapper from "@/components/addDocket/wrapper";
import RouteProps from "@/services/mixins/routeProps";
export default {
  mixins: [RouteProps],
  data() {
    return {
      snackbarText: "",
      snackbarColor: "blue",
      showSnackbar: false,
      addDocketDialog: false
    };
  },
  components: {
    DocketAddWrapper
  },
  methods: {
    addDocket() {
      DocketService.addDocket({ name: "something" })
        .then(result => {
          //console.log("Docket added to db");
          this.snack({ color: "green", text: "Docket was added!" });
        })
        .catch(err => {
          this.snackError();
        });
    },
    deleteAllDockets() {
      DocketService.deleteAllDockets()
        .then(result => {
          this.snack({ color: "blue", text: "All dockets have been deleted." });
        })
        .catch(err => {
          this.snackError();
        });
    },
    toggleView() {
      this.listView = !this.listView;
    }
  },
  computed: {
    listView: {
      get() {
        return this.$store.state.dockets.listView;
      },
      set(val) {
        this.$store.commit("dockets/setState", {
          prop: "listView",
          value: val
        });
      }
    }
  }
};
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>
